const isGuid = (v) =>
  typeof v === "string" &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v);

const buildLabel = (firstName, lastName, email) => {
  const name = [firstName, lastName].filter(Boolean).join(" ").trim();
  return name ? `${name} (${email})` : email;
};

/** Active unless the API explicitly marks the user inactive. Missing `is_active` stays eligible. */
export const isActiveSponsorUser = (user) => user?.is_active !== false;

/** Maps a sponsor-user row (from the identity list) to a BadgeMultiSelect option keyed by email. */
export const userToOption = (u) => {
  const email = (u.email ?? "").trim().toLowerCase();
  return {
    value: email,
    label: buildLabel(u.first_name, u.last_name, email),
    email,
    first_name: u.first_name ?? "",
    last_name: u.last_name ?? "",
    role: u.role ?? "",
    sponsor_user_id: isGuid(u.id) ? u.id : undefined,
  };
};

/** Maps a persisted global-notification-user row (from SponsorService) to a selected option. */
export const savedToOption = (u) => {
  const email = (u.email ?? "").trim().toLowerCase();
  return {
    value: email,
    label: buildLabel(u.first_name, u.last_name, email),
    email,
    first_name: u.first_name ?? "",
    last_name: u.last_name ?? "",
    role: u.role ?? "",
    sponsor_user_id: u.sponsor_user_id ?? undefined,
  };
};

export const toPayload = (selected) =>
  (selected ?? []).map((s) => ({
    sponsor_user_id: s.sponsor_user_id ?? null,
    email: s.email,
    first_name: s.first_name ?? "",
    last_name: s.last_name ?? "",
    role: s.role ?? "",
  }));

export { isGuid, buildLabel };
